import React, { useState, useEffect } from "react";
import styles from "../BulkUploadTabs.module.css";
import Button from "../../../component/button/Button";
import InputText from "../../../component/inputText/InputText";
import { FaGlobe } from "react-icons/fa";
import { postMRSSFeed } from "../../../api/bulk-upload-api";
import { showToast} from "../../../utils/Toastify/Toastify";

const FeedImport = () => {
  const [feedUrl, setFeedUrl] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  const isValidUrl = (string) => {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  };

  useEffect(() => {
    if (feedUrl.trim() !== "" && isValidUrl(feedUrl)) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [feedUrl]);

  const handleLoadFeed = async () => {
    setLoading(true);
    try {
      const response = await postMRSSFeed({ feed_url: feedUrl });
      showToast(response?.data?.message, "success");
    } catch (error) {
      showToast(
        error?.response?.data?.message || "Error loading feed",
        "error"
      );
    }
    finally {
      setLoading(false);
      setFeedUrl("")
    }
  };

  return (
    <>
      <div className={styles.XMLwrapper}>
        {/* Title Section */}
        <h1 className={styles.XMLtitle}>XML/MRSS Feed Import</h1>
        <p className={styles.subtitle}>
          Import content from RSS, MRSS, ATOM, or custom XML feeds
        </p>

        {/* Input Card */}
        <div className={styles.card}>
          <div className={styles.feedInputLabel}>
            <label htmlFor="feedUrl">XML/MRSS Feed URL</label>
          </div>
          <div className={styles.feedInputSection}>
            <div style={{ width: "75%" }}>
              <InputText
                id="feedUrl"
                type="text"
                placeholder="Enter feed URL (e.g., https://example.com/feed.xml)"
                className={styles.feedInput}
                style={{ width: "100%" }}
                value={feedUrl}
                onChange={(e) => setFeedUrl(e.target.value)}
              />
            </div>
            <div>
              <Button
                className={styles.XMLloadButton}
                iconLeft={<FaGlobe className={styles.XMLloadIcon} />}
                onClick={handleLoadFeed}
                loading={loading}
                disabled={disabled} 
              >
                Load Feed
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeedImport;
